/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { colors } from "../../colors";
import { StyledText } from "../../../assets/typography/typography";
import { useDropzone } from "react-dropzone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import {
  FileUploadFormat,
  mapFileFormatToString,
} from "../inputs/FileUploadInput";

type Props = {
  multiple?: boolean;
  onDrop?: (acceptedFiles: File[]) => void;
  accept: FileUploadFormat;
};

const wrapperStyle = css`
  display: flex;
  flex-direction: column;
  background-color: ${colors.whiteHover};
  gap: 8px;
  width: 100%;
  padding: 32px;
  border-radius: 8px;
  border: 1px dashed ${colors.greyBorder};
  align-items: center;
  justify-content: center;
  &:hover {
    border: 1px dashed ${colors.blueInteractive};
  }
  > input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
`;

const uploadTextStyle = css`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

export const FileUploadField = ({ multiple, onDrop, accept }: Props) => {
  const { getRootProps, getInputProps } = useDropzone({
    multiple,
    onDrop,
    accept,
  });

  return (
    <div css={wrapperStyle} {...getRootProps()}>
      <input {...getInputProps()} />
      <StyledText className="bodyTextRegular mb-0" css={uploadTextStyle}>
        <FontAwesomeIcon icon={solid("upload")} />
        Upload file
      </StyledText>
      <StyledText className="bodyTextRegular mb-0">
        Drag and drop your {mapFileFormatToString(accept)} here, or{" "}
        <span>click to choose file</span>
      </StyledText>
      {accept && (
        <StyledText
          color={colors.textSecondary}
          className="bodyTextRegular mb-0"
        >
          ({accept?.split(",").join(", ")})
        </StyledText>
      )}
    </div>
  );
};
